import { ProductService } from 'src/app/shared/services/product.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  IDatosContratanteProducto,
  IDatosContratanteRentista,
  IRegion,
  IComuna,
  ICiudad,
  IBanco,
  ITipoCuenta,
  IPolizaVitalicia,
} from 'src/app/shared/Entities/entities';
import {
  validatePhone,
  validateEmail,
  validateNumCte,
} from 'src/app/shared/helpers/customValidators';
import { Subscription } from 'rxjs';
import { UbicationService } from 'src/app/shared/services/ubication.service';
import { PersonService } from 'src/app/shared/services/person.service';
import { formateaRut } from 'src/app/shared/helpers/helper';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { MatDialog } from '@angular/material';
import { statusEnum } from 'src/app/shared/helpers/constants';
import { DialogMessageModalComponent } from 'src/app/shared/components/dialog-message-modal/dialog-message-modal.component';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-card-contratante-vitalicia',
  templateUrl: './card-contratante-vitalicia.component.html',
  styleUrls: ['./card-contratante-vitalicia.component.sass'],
})
export class CardContratanteVitaliciaComponent implements OnInit, OnDestroy {
  datoContratante: IDatosContratanteRentista;
  datoContratanteRentista: IDatosContratanteRentista;
  editMode = false;
  loading = false;
  error = false;
  @Input() idPoliza: string;
  @Input() tipoSeguro = '';
  @Input() lineaNegocio = '';
  @Input() numPersona: string;
  @Output() getDatosContratante$ = new EventEmitter();
  getErrorMessage = getErrorMessage;
  form: FormGroup;
  FechaCierre: Date;
  Rentista: IDatosContratanteRentista;
  resumen: IPolizaVitalicia;
  tiposCuenta: ITipoCuenta[] = [];
  Cuenta: ITipoCuenta = { CodigoTipo: '', Nombre: '' };
  regiones: IRegion[] = [];
  bancos: IBanco[] = [];
  comunas: IComuna[] = [];
  comunasComerc: IComuna[] = [];
  comunasCorres: IComuna[] = [];
  ciudades: ICiudad[] = [];
  ciudadesComerc: ICiudad[] = [];
  ciudadesCorres: ICiudad[] = [];
  private subscriptions: Subscription[] = [];
  FechaMensaje: string;
  ErrorCuenta: boolean;
  ErrorBanco: boolean;

  // private dataSubs: Subscription;
  constructor(
    private personService: PersonService,
    private ubicationService: UbicationService,
    private productService: ProductService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private appInsightsService: AppInsightsService
  ) {}

  ngOnInit() {
    this.loadData();
    this.loadRegion();
    this.loadBancos();
    this.loadPoliza();
    this.FechaCierreRRVV();
    this.ErrorCuenta = false;
    this.dialog.closeAll();
  }
  loadPoliza() {
    const getDescargaPolizaSubs = this.productService
      .getDetalleVitalicia(this.idPoliza, this.tipoSeguro, this.numPersona)
      .subscribe(
        data => {
          this.loading = false;
          this.resumen = data;
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );
    this.subscriptions.push(getDescargaPolizaSubs);
  }

  llenarFormulario() {
    let BancoAux = '0';
    this.bancos.forEach(ListaBanco => {
      if (ListaBanco.NombreBanco === this.resumen.Banco) {
        BancoAux = ListaBanco.Codigo;
      }
    });
    this.form = this.formBuilder.group({
      Telefono: [this.datoContratante.TelefonoParticular, [validatePhone]],
      Correo: [this.datoContratante.Mail, [validateEmail]],
      Direccion: [this.datoContratante.Direccion, [Validators.maxLength(100)]],
      // RegionCodigo: [this.datoContratante.CodigoRegion],
      CiudadCodigo: [this.datoContratante.Ciudad],
      ComunaCodigo: [this.datoContratante.Comuna.toString()],
      BancoCodigo: [BancoAux],
      NumeroCuenta: [this.resumen.CuentaBancaria],
      celular: [this.datoContratante.TelefonoCelular, [validatePhone]],
      // TipoCuenta: [this.resumen.tipo],
    });
  }

  onEditMode() {
    this.editMode = true;
    this.appInsightsService.trackEvent(Event.pidsBtnModifyData);
    this.llenarFormulario();
  }
  offEditMode() {
    this.editMode = false;
  }
  resetForm() {
    this.form.reset();
  }

  loadRegion() {
    this.ubicationService.getRegiones().subscribe(regiones => {
      this.regiones = regiones;
    });
  }

  FechaCierreRRVV() {
    this.personService.GetFechaCierreRRVV().subscribe(data => {
      const dateString = data[0].Descripcion;
      this.FechaCierre = new Date(dateString);
      this.FechaMensaje =
        ' ' +
        this.FechaCierre.getDate() +
        ' de ' +
        this.Getmonth(this.FechaCierre.getMonth()) +
        ' a las ' +
        this.FechaCierre.getHours() +
        ':' +
        '00 hrs., ';
    });
  }
  Getmonth(mesEntrada) {
    const month = new Array();
    month[0] = 'Enero';
    month[1] = 'Febrero';
    month[2] = 'Marzo';
    month[3] = 'Abril';
    month[4] = 'Mayo';
    month[5] = 'Junio';
    month[6] = 'Julio';
    month[7] = 'Agosto';
    month[8] = 'Septiembre';
    month[9] = 'Octubre';
    month[10] = 'Noviembre';
    month[11] = 'Diciembre';
    const MesSalida = month[mesEntrada];
    return MesSalida;
  }

  getNombreRegionByCodigo(code: string) {
    if (!code || !this.regiones) {
      return '-';
    }
    const element = this.regiones.find(x => x.CodigoRegion === code);
    return element ? element.Nombre : '';
  }

  getNombreCuidadByCodigo(code: string, dirType: string) {
    let element = {} as ICiudad;
    switch (dirType) {
      case 'direccion':
        if (!code || !this.ciudades) {
          return '-';
        }
        element = this.ciudades.find(x => x.CodigoCiudad === code);
        break;
      case 'direccionComerc':
        if (!code || !this.ciudadesComerc) {
          return '-';
        }
        element = this.ciudadesComerc.find(x => x.CodigoCiudad === code);
        break;
      case 'direccionCorres':
        if (!code || !this.ciudadesCorres) {
          return '-';
        }
        element = this.ciudadesCorres.find(x => x.CodigoCiudad === code);
        break;
      default:
        element.Nombre = '';
        break;
    }

    return element.Nombre;
  }

  getNombreComunaByCodigo(code: string, dirType: string) {
    let element = {} as IComuna;
    switch (dirType) {
      case 'direccion':
        if (!code || !this.comunas) {
          return '-';
        }
        element = this.comunas.find(x => x.CodigoComuna === code);
        break;
      case 'direccionComerc':
        if (!code || !this.comunasComerc) {
          return '-';
        }
        element = this.comunasComerc.find(x => x.CodigoComuna === code);
        break;
      case 'direccionCorres':
        if (!code || !this.comunasCorres) {
          return '-';
        }
        element = this.comunasCorres.find(x => x.CodigoComuna === code);
        break;
      default:
        element.Nombre = '';
        break;
    }

    return element.Nombre;
  }

  loadData() {
    this.loading = true;
    this.error = false;
    const dataSubs = this.personService
      .getDatosContratanteRentista(
        this.idPoliza,
        this.lineaNegocio,
        this.tipoSeguro
      )
      .subscribe(
        data => {
          this.loading = false;
          this.datoContratante = data;
          this.getDatosContratante$.emit(this.datoContratante);
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );

    this.subscriptions.push(dataSubs);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  formatRUT(rut: string) {
    return formateaRut(rut);
  }

  getFullName() {
    if (!this.datoContratante) {
      return '';
    }

    return `${this.datoContratante.Nombre ? this.datoContratante.Nombre : ''} ${
      this.datoContratante.ApellidoPaterno
        ? this.datoContratante.ApellidoPaterno
        : ''
    } ${
      this.datoContratante.ApellidoMaterno
        ? this.datoContratante.ApellidoMaterno
        : ''
    }`;
  }

  save() {
    if (!this.form.valid || !this.form.dirty) {
      return;
    }

    this.appInsightsService.trackEvent(Event.pidsBtnSaveModifyData);

    const EnvioDatos: any = {
      poliza: this.idPoliza,
      Rut: this.datoContratante.Rut,
      Nombre: this.datoContratante.Nombre,
      ApellidoPaterno: this.datoContratante.ApellidoPaterno,
      ApellidoMaterno: this.datoContratante.ApellidoMaterno,
      Comuna: this.datoContratante.Comuna,
      Ciudad: this.datoContratante.Ciudad,
      NumeroPersona: this.numPersona,
      FormaPago: '10',
      TipoSeguro: this.tipoSeguro,
      ...this.form.value,
    };

    // if (EnvioDatos.BancoCodigo !== '') {
    //   if (EnvioDatos.NumeroCuenta === '') {
    //     this.ErrorCuenta = true;
    //     this.form.markAsDirty();
    //     return;
    //   } else {
    //     EnvioDatos.FormaPago = '01';
    //     EnvioDatos.BancoCodigo = '0';
    //   }
    // }

    if (EnvioDatos.BancoCodigo !== '') {
      if (EnvioDatos.NumeroCuenta !== '') {
        this.ErrorCuenta = false;
      }
      if (EnvioDatos.NumeroCuenta === '') {
        this.ErrorCuenta = true;
        this.form.markAsDirty();
        return;
      }
    } else {
      if (EnvioDatos.NumeroCuenta !== '') {
        this.ErrorBanco = true;
        this.form.markAsDirty();
        return;
      }
      if (EnvioDatos.NumeroCuenta === '') {
        this.ErrorBanco = false;
        EnvioDatos.FormaPago = '8';
        EnvioDatos.BancoCodigo = '0';
      }
    }
    if (this.ErrorCuenta || this.ErrorBanco) {
      return;
    }
    if (this.ErrorCuenta || this.ErrorBanco) {
      return;
    }

    // const data: any = {
    //   //  ...this.data,
    //    ...this.form.value,
    // };
    this.personService.postDatosRentista(EnvioDatos).subscribe(
      res => {
        this.editMode = false;
        this.dialog.open(DialogMessageModalComponent, {
          data: {
            title: 'DATOS GUARDADOS',
            message: 'Datos guardados correctamente.',
            type: statusEnum.success,
          },
          height: '10.3125rem',
          width: '18.125rem',
        });
        this.loadData();
        this.loadPoliza();
      },
      error => {
        this.dialog.open(DialogMessageModalComponent, {
          data: {
            title: 'HA OCURRIDO UN PROBLEMA',
            message: 'Inténtelo más tarde.',
            type: statusEnum.error,
          },
          height: '10.3125rem',
          width: '18.125rem',
        });
      }
    );
  }
  loadBancos() {
    // this.personService.getBancos('COLECTIVOS').subscribe(bancos => {
    //   this.bancos = bancos;
    // });
    let BancoAux = {
      Codigo: '46',
      NombreBanco: 'ABN AMBRO BANK',
      CodigoBanco: '0046',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '504',
      NombreBanco: 'BANCO BBVA',
      CodigoBanco: '0504',
    };
    this.bancos.push(BancoAux);
    BancoAux = { Codigo: '28', NombreBanco: 'BANCO BICE', CodigoBanco: '0028' };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '33',
      NombreBanco: 'BANCO CITIBANK',
      CodigoBanco: '0033',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '55',
      NombreBanco: 'BANCO CONSORCIO EX MONEX',
      CodigoBanco: '0055',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '1',
      NombreBanco: 'BANCO DE CHILE',
      CodigoBanco: '10001',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '16',
      NombreBanco: 'BANCO DE CREDITO E INVERSIONES',
      CodigoBanco: '0016',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '43',
      NombreBanco: 'BANCO DE LA NACION ARGENTINA',
      CodigoBanco: '0043',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '507',
      NombreBanco: 'BANCO DEL DESARROLLO',
      CodigoBanco: '0507',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '12',
      NombreBanco: 'BANCO DEL ESTADO',
      CodigoBanco: '0012',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '17',
      NombreBanco: 'BANCO DO BRASIL',
      CodigoBanco: '0017',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '51',
      NombreBanco: 'BANCO FALABELLA',
      CodigoBanco: '0601',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '9',
      NombreBanco: 'BANCO INTERNACIONAL',
      CodigoBanco: '0009',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '39',
      NombreBanco: 'BANCO ITAÚ (BOSTON)',
      CodigoBanco: '0039',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '57',
      NombreBanco: 'BANCO PARIS',
      CodigoBanco: '0603',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '56',
      NombreBanco: 'BANCO PENTA',
      CodigoBanco: '0056',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '53',
      NombreBanco: 'BANCO RIPLEY',
      CodigoBanco: '0602',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '37',
      NombreBanco: 'BANCO SANTANDER',
      CodigoBanco: '10037',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '0035',
      NombreBanco: 'BANCO SANTIAGO',
      CodigoBanco: '0035',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '49',
      NombreBanco: 'BANCO SECURITY',
      CodigoBanco: '0049',
    };
    this.bancos.push(BancoAux);
    BancoAux = { Codigo: '27', NombreBanco: 'CORPBANCA', CodigoBanco: '0027' };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '52',
      NombreBanco: 'DEUTSCHE BANK',
      CodigoBanco: '0052',
    };
    this.bancos.push(BancoAux);
    BancoAux = { Codigo: '54', NombreBanco: 'HNS BANCO', CodigoBanco: '0054' };
    this.bancos.push(BancoAux);
    BancoAux = { Codigo: '31', NombreBanco: 'HSBC BANK', CodigoBanco: '0031' };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '41',
      NombreBanco: 'JP MORGAN CHASE BANK N.A.',
      CodigoBanco: '0041',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '14',
      NombreBanco: 'SCOTIABANK SUD AMERICANO',
      CodigoBanco: '0014',
    };
    this.bancos.push(BancoAux);
    BancoAux = {
      Codigo: '45',
      NombreBanco: 'THE BANK OF TOKYO',
      CodigoBanco: '0045',
    };
    this.bancos.push(BancoAux);
  }

  // ValidarFechaActualFechaCierre() {
  //   const FechaActual = new Date();
  //   const diffMs = this.FechaCierre.getTime() - FechaActual.getTime();
  //   const diffHrs = Math.floor(diffMs / 3600000);
  // }

  ValidarNumCte(event: any) {
    const Form: any = {
      ...this.form.value,
    };
    if (Form.BancoCodigo !== '') {
      if (event.target.value !== '') {
        this.ErrorCuenta = false;
        return;
      }
      if (event.target.value === '') {
        this.ErrorCuenta = true;
        this.form.markAsDirty();
        return;
      }
    } else {
      if (event.target.value !== '') {
        this.ErrorBanco = true;
        this.form.markAsDirty();
        return;
      }
      if (event.target.value === '') {
        this.ErrorBanco = false;
        return;
      }
    }
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.pidsAccShowRentier);
  }
}
